// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ngw-gui-action-toolbar {
  display: flex;
  gap: 8px;
  text-wrap: nowrap;
  align-items: center;
}
.ngw-gui-action-toolbar .spacer {
  flex-grow: 1;
}
`, "",{"version":3,"sources":["webpack://./package/nextgisweb/nextgisweb/gui/nodepkg/action-toolbar/ActionToolbar.less"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;AACJ;AALA;EAOQ,YAAA;AACR","sourcesContent":[".ngw-gui-action-toolbar {\n    display: flex;\n    gap: 8px;\n    text-wrap: nowrap;\n    align-items: center;\n\n    .spacer {\n        flex-grow: 1;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
